import { UUID } from 'v2/core/entities/uuid';
import { ReportSchedule } from 'v2/core/repository/edge-server/analysis/types';
import { SubjectType } from 'v2/core/repository/edge-server/types';

export interface CreateScheduleInput {
  cron: CronInput;
  outbounds: string[];
  subjectID: UUID;
  subjectType: SubjectType;
  reportType: ReportingType;
  metadata: ScheduleMetadata;
  tenantID: UUID;
  isPrimary?: boolean;
}

export interface CreateScheduleResponse {
  id: UUID;
}

export interface UpdateScheduleInput {
  id: UUID;
  tenantID: UUID;
  cron?: CronInput;
  metadata?: ScheduleMetadata;
  outbounds?: string[];
  isDisabled?: boolean;
}

export interface UpdateScheduleResponse {
  updated: boolean;
}

export interface DeleteScheduleInput {
  id: UUID;
  tenantID: UUID;
}

export interface DeleteScheduleResponse {
  deleted: boolean;
}

export interface Reporting {
  primarySchedule?: ReportSchedule;
  secondarySchedules?: ReportSchedule[];
}

export interface DashboardReportScheduleResponse {
  cron: Cron;
  outbounds?: UUID[];
  reportType: ReportingType.DefaultReport;
}

export enum ReportingType {
  DefaultReport = 'DEFAULT_REPORT',
  FeedbackReport = 'FEEDBACK_REPORT',
}

export interface ScheduleMetadata {
  feedbackReportMetadata?: FeedbackReportMetadata;
}

export interface FeedbackReportMetadata {
  recordCount: FeedbackReportLimits;
}

export interface Cron {
  value?: CronMonthValue | CronWeekValue | CronDayValue | CronHourValue;
  realtime?: boolean;
}

interface CronMonthValue {
  unit: CronUnit.Month;
  count: number;
  offset?: CronWeekValue | CronDayValue | CronHourValue;
}
interface CronWeekValue {
  unit: CronUnit.Week;
  count: number;
  offset?: CronDayValue | CronHourValue;
}
interface CronDayValue {
  unit: CronUnit.Day;
  count: number;
  offset?: CronHourValue;
}
interface CronHourValue {
  unit: CronUnit.Hour;
  count: number;
}

export interface CronInput {
  value?:
    | CronMonthValueInput
    | CronWeekValueInput
    | CronDayValueInput
    | CronHourValueInput;
  realtime?: boolean;
}

interface CronMonthValueInput {
  unit: CronUnit.Month;
  count: number;
  offset: CronWeekValueInput | CronDayValueInput | CronHourValueInput;
}

export interface CronWeekValueInput {
  unit: CronUnit.Week;
  count: number;
  offset: CronDayValueInput | CronHourValueInput;
}

export interface CronDayValueInput {
  unit: CronUnit.Day;
  count: number;
  offset: CronHourValueInput;
}

export interface CronHourValueInput {
  unit: CronUnit.Hour;
  count: number;
}

export enum CronUnit {
  Hour = 'HOUR',
  Day = 'DAY',
  Week = 'WEEK',
  Month = 'MONTH',
}

export enum FeedbackReportLimits {
  TOP_3 = 3,
  TOP_5 = 5,
  TOP_10 = 10,
}

export enum DashboardReport {
  DefaultReport = 'DEFAULT_REPORT',
}
